import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import './MaintenanceScreen.css'

class MaintenanceScreen extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {}
    }

    public render() {
        return (
            <div className="maintenanceDiv">
                <Image className="mx-auto d-block" src="./Images/MaintenanceScreen/MaintenanceScreen.png" />
                <h3 className="maintenance-text mt-5">We’re doing some maintenance.<br />It won’t take long :)</h3>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

export default connect(mapStateToProps)(MaintenanceScreen);